export default "__VITE_ASSET__3cb4639d__"